<template>
  <div>
    <!-- <span class="basisInformation">科室管理</span> -->

    <el-row :gutter="12">
      <el-col :span="18" class="col-header">
        <el-card shadow="never"> 科室管理</el-card>
      </el-col>

      <el-col :span="6" class="col-button" v-if="authSource == 'system'">
        <el-button type="primary" size="medium" @click="addkesi"
          >新增科室</el-button
        >
      </el-col>
    </el-row>

    <!-- <el-divider></el-divider> -->
    <!-- 头部搜索新增区域 -->
    <!-- <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-input
          size="small"
          placeholder="请输入您要查询的科室名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="addkesiDialog = true"
          >新增</el-button
        >
      </el-form-item>
    </el-form> -->

    <!-- 表格区域 -->
    <el-table
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      stripe
      :data="departmentList"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="departmentSort"
        label="序号"
        width="80"
        sortable
        align="center"
      >
      </el-table-column>
      <el-table-column prop="departmentName" label="科室名称" align="center">
      </el-table-column>
      <el-table-column
        prop="departmentMastername"
        label="负责人"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="departmentCode"
        label="编号"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        v-if="authSource == 'system'"
      >
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="editorHandler(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            class="delete_btn"
            @click="schoolDeleteDepartment(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑科室信息 -->
    <el-dialog
      title="科室编辑"
      :visible.sync="kesiDialog"
      :before-close="updataDepartClose"
      width="650px"
    >
      <el-form :model="kesiform" :rules="rules" ref="updatakeshi">
        <el-form-item label="上级机构" label-width="120px">
          <el-input
            v-model="schoolName"
            style="width: 300px"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="科室编号"
          prop="departmentCode"
          label-width="120px"
        >
          <el-input
            maxlength="20"
            v-model.trim="kesiform.departmentCode"
            oninput="value=value.replace(/[^0-9]/g,'')"
            style="width: 300px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="科室名称"
          prop="departmentName"
          label-width="120px"
        >
          <el-input
            maxlength="20"
            v-model.trim="kesiform.departmentName"
            style="width: 300px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="科室负责人"
          prop="departmentMastername"
          label-width="120px"
        >
          <el-input
            v-model="kesiform.departmentMastername"
            style="width: 300px"
            autocomplete="off"
            disabled
          ></el-input>
          <el-button type="primary" class="teacher_btn" @click="teacherhandler"
            >选择教师</el-button
          >
        </el-form-item>
        <el-form-item label="序号1" prop="departmentSort" label-width="120px">
          <el-input
            v-model.number="kesiform.departmentSort"
            maxlength="20"
            oninput="value=value.replace(/[^0-9]/g,'')"
            style="width: 300px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="kesiDialogStudent" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="schoolDepartment('updatakeshi')"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 新增科室 -->
    <el-dialog
      title="新增科室"
      :visible.sync="addkesiDialog"
      :before-close="addDepartClose"
      width="650px"
    >
      <el-form :model="kesiform" :rules="rules" ref="addkeshi">
        <el-form-item label="上级机构" label-width="120px">
          <el-input
            v-model="schoolName"
            style="width: 300px"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="科室编号"
          prop="departmentCode"
          label-width="120px"
        >
          <el-input
            v-model.trim="kesiform.departmentCode"
            maxlength="20"
            oninput="value=value.replace(/[^0-9]/g,'')"
            style="width: 300px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="科室名称"
          prop="departmentName"
          label-width="120px"
        >
          <el-input
            v-model.trim="kesiform.departmentName"
            maxlength="20"
            style="width: 300px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="科室负责人"
          prop="departmentMastername"
          label-width="120px"
        >
          <el-input
            v-model="kesiform.departmentMastername"
            style="width: 300px"
            autocomplete="off"
            disabled
          ></el-input>
          <el-button type="primary" class="teacher_btn" @click="teacherhandler"
            >选择教师</el-button
          >
        </el-form-item>
        <el-form-item label="序号" prop="departmentSort" label-width="120px">
          <el-input
            v-model.number="kesiform.departmentSort"
            maxlength="20"
            oninput="value=value.replace(/[^0-9]/g,'')"
            style="width: 300px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addkesiSchool" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="schoolDepartment('addkeshi')"
          size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 教师列表 -->
    <el-dialog
      title="请选择教师"
      :visible.sync="teacherListDialog"
      width="780px"
    >
      <el-form :inline="true" :model="teacher">
        <el-form-item label="姓名">
          <el-input
            maxlength="20"
            v-model="teacher.name"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input
            maxlength="11"
            v-model="teacher.mobile"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="teacherLists"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :row-style="{ height: '48px' }"
        :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
        stripe
        :data="teacherList"
        style="margin-bottom: 100px; height: 680px !important"
      >
        <el-table-column
          property="name"
          label="教师姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          property="mobile"
          label="教师手机号"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="kesiform.departmentMasterid == scope.row.id ? false : true"
              type="text"
              @click="handleCurrentChange(scope.row)"
              >设为负责人</el-button
            >
            <el-button
              v-else
              class="delete_btn"
              type="text"
              @click="handleCurrentChangeQ()"
              >取消负责人</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev,pager,next,sizes"
        :total="teacher.totalCount"
        :page-size="teacher.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="teacher.curPage"
        @current-change="currentChange"
        @size-change="handleSizeChange"
        style="bottom: 0"
      ></el-pagination>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="teacherListDialog = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="teacherTable" size="small"
          >确 定</el-button
        >
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import {
  getdepartmentlist,
  teacherLists,
  schoolDepartment,
  schoolDeleteDepartment,
} from '@/api/departmen'
export default {
  data() {
    return {
      authSource: '',
      schoolId: localStorage.getItem('schoolIds'),
      departmentList: [], // 获取全部科室列表
      kesiDialog: false,
      teacherListDialog: false,
      addkesiDialog: false,
      schoolName: localStorage.getItem('schoolName'),
      teacherList: [], //教师列表
      valTableId: '',
      valTablename: '',
      kesiform: {
        departmentCode: '',
        departmentId: '',
        departmentMasterid: '',
        departmentMastername: '',
        departmentName: '',
        departmentSort: '',
      },
      teacher: {
        name: '',
        mobile: '',
        curPage: 0,
        pageSize: 20,
        totalCount: 1,
      },
      rules: {
        departmentCode: [
          { required: true, message: '请输入科室编号', trigger: 'blur' },
        ],
        departmentName: [
          { required: true, message: '请输入科室名称', trigger: 'blur' },
        ],
        // departmentMastername: [
        //   { required: true, message: '请选择教师', trigger: 'blur' },
        // ],
        departmentSort: [
          { required: true, message: '请输入序号', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    this.authSource = localStorage.getItem('authSource')
    this.getdepartmentlist()
  },
  methods: {
    reset() {
      this.kesiform.departmentCode = ''
      this.kesiform.departmentId = ''
      this.kesiform.departmentMasterid = ''
      this.kesiform.departmentMastername = ''
      this.kesiform.departmentName = ''
      this.kesiform.departmentSort = ''
    },
    addkesi() {
      this.reset()
      this.addkesiDialog = true
    },
    // 科室编辑Close事件
    updataDepartClose() {
      this.reset()
      this.kesiDialog = false
      this.$refs.updatakeshi.resetFields()
    },
    // 科室新增Close事件
    addDepartClose() {
      this.addkesiDialog = false
      this.reset()
      this.$refs.addkeshi.resetFields()
    },
    // 科室新增取消事件
    addkesiSchool() {
      this.reset()
      this.$refs.addkeshi.resetFields()
      this.addkesiDialog = false
    },
    //科室修改取消事件
    kesiDialogStudent() {
      this.reset()
      // this.$refs.updatakeshi.resetFields()
      var kesiforms = {
        departmentCode: '',
        departmentId: '',
        departmentMasterid: '',
        departmentMastername: '',
        departmentName: '',
        departmentSort: '',
      }
      this.kesiform = { ...kesiforms }
      this.kesiDialog = false
    },
    // 查询学校科室
    async getdepartmentlist() {
      const { data: res } = await getdepartmentlist({
        schoolId: this.schoolId,
      })
      this.departmentList = res.data
    },
    // 编辑科室信息
    editorHandler(row) {
      this.kesiDialog = true
      this.kesiform.departmentCode = row.departmentCode
      this.kesiform.departmentName = row.departmentName
      this.kesiform.departmentMastername = row.departmentMastername
      this.kesiform.departmentSort = row.departmentSort
      this.kesiform.departmentId = row.departmentId
      this.kesiform.departmentMasterid = row.departmentMasterid
    },

    // 查询教师列表
    async teacherLists() {
      const { data: res } = await teacherLists({
        schoolId: this.schoolId,
        ...this.teacher,
      })
      this.teacherList = res.data.dataList
      this.teacher.totalCount = res.data.totalCount
    },
    // 选择教师
    teacherhandler() {
      this.teacherLists()
      // this.kesiDialog = false
      this.teacherListDialog = true
    },

    // 选中教师
    handleCurrentChange(val) {
      this.kesiform.departmentMasterid = val.id
      this.kesiform.departmentMastername = val.name
      // this.kesiDialog = true
      this.teacherListDialog = false
    },
    // 取消教师
    handleCurrentChangeQ() {
      this.kesiform.departmentMasterid = ''
      this.kesiform.departmentMastername = ''
      this.kesiDialog = true
      this.teacherListDialog = false
    },

    //教师列表分页变化
    currentChange(e) {
      this.teacher.curPage = e
      this.teacherLists()
    },

    handleSizeChange(val) {
      this.teacher.curPage = 1
      this.teacher.pageSize = val
      this.teacherLists()
    },

    teacherTable() {
      this.kesiform.departmentMasterid = this.valTableId
      this.kesiform.departmentMastername = this.valTablename
      this.kesiDialog = true
      this.teacherListDialog = false
    },

    // 保存科室、新增科室
    async schoolDepartment(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.schoolDepartments(formName)
        } else {
          return false
        }
      })
    },
    async schoolDepartments(formName) {
      const params = {
        schoolId: this.schoolId,
        ...this.kesiform,
      }

      if ('addkeshi' == formName) {
        delete params.departmentId
      }
      const { data: res } = await schoolDepartment(params)
      this.$refs[formName].resetFields()
      this.reset()
      this.addkesiDialog = false
      this.kesiDialog = false
      this.getdepartmentlist()
    },

    // 删除科室
    async schoolDeleteDepartment(row) {
      this.$confirm(
        `您确定要将<span style="color:#409EFF;margin:0 10px;"> ${row.departmentName} </span>删除吗？?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          schoolDeleteDepartment(row.departmentId).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            this.getdepartmentlist()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
  },
}
</script>
<style scoped>
.basisInformation {
  font-size: 16px;
  font-weight: 700;
  /* margin-top: 10px; */
}
.el-divider {
  margin-top: 18px;
  margin-bottom: 20px;
}
.el-form {
  margin-bottom: -4px;
  /* height: 40px; */
}
.teacher_btn {
  margin-left: 10px;
}
.el-table .el-button + .el-button {
  margin-left: 20px;
}
.el-pagination {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/Departmen.vue